// extracted by mini-css-extract-plugin
module.exports = {"container":"about-module--container--3FpKq","text":"about-module--text--3UEVt","leftMargin":"about-module--leftMargin--1QjRq"};